import fetchUserAppVersion from './fetchUserAppVersion';

export default {
  fetchUserAppVersion,
};



// WEBPACK FOOTER //
// ./src/app/services/appVersion/index.js